import React, { useEffect } from "react";
import { useState } from "react";
import { useFormik } from "formik";
import MyAutocomplete from "../../../../../../../components/MyAutocomplete";
import { Grid } from "@mui/material";
import { Box, Button } from "@material-ui/core";
import {
    useGeneratedModelCode,
    useMqXS,
} from "../../../../../../../utils/Utils";
import { useHistory, useParams } from "react-router";
import { useAxios } from "../../../../../../../utils/useAxios";
import { useDispatch, useSelector } from "react-redux";
import { UPDATE_SNACKBAR } from "../../../../../../../store/actions/appActions";

import "./style.css";
import { SET_SCHEDE_TARATURA } from "../../../../../../../store/actions/actions";

const A10VO31 = ({ data, readOnly, name }) => {
    const mq_xs = useMqXS();
    const dispatch = useDispatch();
    const params = useParams();
    const history = useHistory();


    const updateSnackbar = (objData) =>
        dispatch({ type: UPDATE_SNACKBAR, value: objData });
    const [initialValues, setInitialValues] = useState(null);
    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        onSubmit: (values) => { },
    });
    const axios = useAxios();
    const [customerNamePickList, setCustomerNamePickList] = useState([]);
    const [pickList, setPickList] = useState({});
    const rdre = params.rdre;

    const modelCode = useGeneratedModelCode();

    const handleClick = () => {
        const copyObject = { ...formik.values };
        dispatch({ type: SET_SCHEDE_TARATURA, value: copyObject });
        if (params?.id_configuration) {
            history.push(
                "/configuration/" +
                params.rdre +
                "/" +
                params.size +
                "/summary/" +
                params?.id_configuration
            );
        } else {
            history.push(
                "/configuration/" + params.rdre + "/" + params.size + "/summary"
            );
        }
    };

    const getPickList = () => {
        axios
            .get("calibration/GetPicklistValue", { params: { rdre: rdre } })
            .then((res) => {
                setPickList(res.data);
            })
            .catch((error) =>
                updateSnackbar({
                    open: true,
                    message: "Unable to get picklists",
                    severity: "error",
                })
            );
    };

    /**
     *
     * @param {ChangeEvent} e event where the input value changes
     * @param {string} fieldName name of the field changed
     * change the value of the input and the computed field based on the field passed as parameter
     */
    const checkCodeIncludes = (code, validCodes) => {
        if (!code) return false; // Se il code è null, undefined o stringa vuota, ritorna false


        return validCodes.includes(code);

    };
    const getNestedValue = (obj, path, defaultValue = 0) => {
        return path.split('.').reduce((acc, key) => acc?.[key], obj) || defaultValue;
    };
    const handleChangeComputedValue = (e, fieldName, fieldValue, dependencyField) => {
        const dependencyValue = getNestedValue(formik.values, dependencyField) || null;
        formik.setFieldValue(
            fieldValue,
            e.target.value
        );

        if (fieldName === "max_displacement") {
            const newValue = parseFloat(e.target.value) || 0;
            const newMaxOutputFlow = (newValue * dependencyValue) / 1000;


            formik.setFieldValue(
                "testing_relevant_data.max_output_flow",
                newMaxOutputFlow
            );


        } else if (fieldName === "min_displacement") {
            const newValue = parseFloat(e.target.value) || 0;
            const newMinOutputValue = (newValue * dependencyValue) / 1000;


            formik.setFieldValue(
                "testing_relevant_data.min_output_flow",
                newMinOutputValue
            );

        } else if (fieldName === "loaded_pump_speed") {
            const newValue = parseFloat(e.target.value) || 0;
            const newMinOutputValue = (newValue * formik?.values?.testing_relevant_data?.min_displacement) / 1000;
            const newMaxOutputValue = (newValue * formik?.values?.testing_relevant_data?.max_displacement) / 1000;


            formik.setFieldValue(
                "testing_relevant_data.min_output_flow",
                newMinOutputValue
            );
            formik.setFieldValue(
                "testing_relevant_data.max_output_flow",
                newMaxOutputValue
            );
        } else {
            const newDifferentialB = parseFloat(e.target.value) || 0;

            const newReliefValveBSetting =
                newDifferentialB +
                (formik?.values?.testing_relevant_data?.boost_pressure_at_load_speed ||
                    0);

            formik.setFieldValue(
                "testing_relevant_data.differential_pressure_valve_b",
                e.target.value
            );
            formik.setFieldValue(
                "testing_relevant_data.reliefvalve_b_setting_abs",
                newReliefValveBSetting
            );
            if (
                newReliefValveBSetting > 500 &&
                formik?.values?.customer_data?.special_release_no === "Not specified"
            ) {
                formik.setFieldValue("customer_data.special_release_no", "");
            } else if (newReliefValveBSetting < 500) {
                formik.setFieldValue(
                    "customer_data.special_release_no",
                    "Not specified"
                );
            }
        }
    };



    useEffect(() => {
        // getCalibration();
        getPickList();
        if (data?.discountInfo) {
            const item = data.discountInfo.find((d) => d.type === "customer");

            setCustomerNamePickList([
                {
                    id: 1,
                    value: "No",
                },
                {
                    id: 2,
                    value: item.optionValue,
                },
            ]);
        }

        if (data?.schedeTaratura) {
            Object.keys(data?.schedeTaratura?.testing_relevant_data).forEach(
                (key) => {
                    if (
                        data.schedeTaratura.testing_relevant_data[key] &&
                        (key !== "nominal_voltage" ||
                            key !== "pressurecutoff_fstep1_adj_to")
                    ) {
                        data.schedeTaratura.testing_relevant_data[key] = parseFloat(
                            data.schedeTaratura.testing_relevant_data[key]
                        );
                    }
                }
            );
        }

        const values = {
            info: {
                version_text: data?.schedeTaratura?.info?.version_text || "",
            },
            general_info_features: {
                material_description: modelCode || "",
            },
            customer_data: {
                rd_sheet_prospectus:
                    data?.schedeTaratura?.customer_data.rd_sheet_prospectus || "RE92004",
                customer: data?.schedeTaratura?.customer_data?.customer || {
                    id: 0,
                    value: "No",
                },
                customer_pn: data?.schedeTaratura?.customer_data?.customer_pn || "",
                // special_release_horb:
                //     data?.schedeTaratura?.testing_relevant_data?.special_release_horb || "", //dipende dal campo b38
                name_plate_standard:
                    !data?.schedeTaratura?.customer_data?.customer || data?.schedeTaratura?.customer_data?.customer === "No"
                        ? "standard without customer number"
                        : "standard with customer number", //se c'è il customer allora "standard with customer number", se no "standard without customer number
                approval_company_external:
                    data?.accessories?.find(
                        (a) => a.value && a.value.accessory === "Register Classification"
                    )?.value?.value !== "Yes"
                        ? {
                            id: 233,
                            value: "Standard(without homologation)",
                        }
                        : data?.schedeTaratura?.customer_data?.approval_company_external ||
                        null,
                test_certificate:
                    data?.accessories?.find(
                        (a) => a.value.accessory === "Test Certificates"
                    )?.value?.value === "No"
                        ? {
                            id: 250,
                            value: "without",
                        }
                        : data?.schedeTaratura?.customer_data?.test_certificate || null,
                language_code_f_test_certif:
                    data?.accessories?.find(
                        (a) => a.value.accessory === "Test Certificates"
                    )?.value?.value === "No"
                        ? {
                            id: 276,
                            value: "without",
                        }
                        : data?.schedeTaratura?.customer_data
                            ?.language_code_f_test_certif || null,
                paintprimer:
                    data?.accessories?.find((a) => a.family === "S6" || a.family === "S4")?.value?.value ===
                        "No" &&
                        data?.accessories?.find((a) => a.family === "S7" || a.family === "S5")?.value?.value ===
                        "No"
                        ? {
                            id: 142,
                            value: "without",
                        }
                        : data?.schedeTaratura?.customer_data?.paintprimer || null,
                painttop_coat:
                    data?.accessories?.find((a) => a.family === "S7" || a.family === "S5")?.value?.value ===
                        "No"
                        ? {
                            id: 185,
                            value: "without",
                        }
                        : data?.schedeTaratura?.customer_data?.painttop_coat || null,
                paint_specification:
                    data?.accessories?.find((a) => a.family === "S6" || a.family === "S4")?.value?.value ===
                        "No" &&
                        data?.accessories?.find((a) => a.family === "S7" || a.family === "S5")?.value?.value ===
                        "No"
                        ? {
                            id: 222,
                            value: "without",
                        }
                        : data?.schedeTaratura?.customer_data?.paint_specification || null,

            },

            testing_relevant_data: {
                max_displacament:
                    data?.schedeTaratura?.testing_relevant_data?.max_displacament || null,
                min_displacament:
                    data?.schedeTaratura?.testing_relevant_data?.min_displacament || null,
                loaded_pump_speed:
                    data?.schedeTaratura?.testing_relevant_data?.loaded_pump_speed ||
                    null,
                max_output_flow:
                    data?.schedeTaratura?.testing_relevant_data?.max_output_flow || '',
                min_output_flow:
                    data?.schedeTaratura?.testing_relevant_data?.min_output_flow || '',
                pressure_regulation_setting_b:
                    data?.schedeTaratura?.testing_relevant_data?.pressure_regulation_setting_b || '',
                differential_pressure_fr:
                    data?.schedeTaratura?.testing_relevant_data?.differential_pressure_fr || '',
                standby_pressure_g_controller:
                    data?.schedeTaratura?.testing_relevant_data
                        ?.standby_pressure_g_controller || '',
                standby_pressure_ed:
                    data?.schedeTaratura?.testing_relevant_data
                        ?.standby_pressure_ed || '',
                standby_pressure_er:
                    data?.schedeTaratura?.testing_relevant_data?.standby_pressure_er ||
                    0,
                input_power:
                    data?.schedeTaratura?.testing_relevant_data
                        ?.input_power || '',
                input_torque:
                    data?.schedeTaratura?.testing_relevant_data
                        ?.input_torque || '',
            },
            special_features: {
                note: data?.schedeTaratura?.special_features?.note || "",
            },
        };

        setInitialValues(values);
    }, [data]);

    useEffect(() => {
        const result = (formik?.values?.testing_relevant_data?.input_power * 60000) / (2 * Math.PI * formik?.values?.testing_relevant_data?.loaded_pump_speed);
        if (!formik?.values?.testing_relevant_data?.loaded_pump_speed || !formik?.values?.testing_relevant_data?.input_power) {
            return null; // Ritorna null se uno dei due valori è mancante
        }
        if (result) {
            formik.setFieldValue(
                "testing_relevant_data.input_torque",
                result
            );
        }

    }, [formik?.values?.testing_relevant_data?.loaded_pump_speed, formik?.values?.testing_relevant_data?.input_power]);

    // 

    return (
        <form
            id="schede_taratura_form"
            style={{
                padding: "24px",
                borderRadius: "20px",
                backgroundColor: "white",
            }}
            onSubmit={formik.handleSubmit}
        >
            <h1> Scheda di taratura {name}</h1>
            <Grid container spacing={2}>

                <Grid item xs={12}>
                    <h2>General Info Features</h2>
                </Grid>

                <Grid item xs={4}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                        Material Description
                    </p>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "15px 20px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "15px",
                            position: "relative",
                            boxShadow:
                                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                        }}
                    >
                        <input
                            disabled={true}
                            style={{
                                outline: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                            }}
                            name={"general_info_features.material_description"}
                            value={
                                formik?.values?.general_info_features?.material_description ||
                                ""
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <h2>Customer Data</h2>
                </Grid>

                {/* //customer name */}
                <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>Customer name</p>

                    <MyAutocomplete
                        isMultiple={false}
                        defaultValue={formik?.values?.customer_data?.customer || null} // Valore di default del campo customer
                        onChange={(e, c) => {
                            formik.setFieldValue("customer_data.customer", c);


                            if (c.value === "No") {
                                formik.setFieldValue(
                                    "customer_data.name_plate_standard",
                                    "standard without customer number"
                                );
                            } else {
                                formik.setFieldValue(
                                    "customer_data.name_plate_standard",
                                    "standard with customer number"
                                );
                            }

                        }}
                        disabled={readOnly}
                        data={customerNamePickList} // Lista di opzioni
                        name="customer_data.customer"
                        label={""}
                    />
                </Grid>

                {formik?.values?.customer_data?.customer &&
                    formik?.values?.customer_data?.customer?.value !== "No" && (
                        <Grid item xs={3}>
                            <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                                Customer p/n
                            </p>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "15px 20px",
                                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                                    borderRadius: "15px",
                                    position: "relative",
                                    boxShadow:
                                        "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                                }}
                            >
                                <input
                                    style={{
                                        outline: "none",
                                        border: "none",
                                        backgroundColor: "transparent",
                                        width: "100%",
                                    }}
                                    disabled={readOnly}
                                    name={"customer_data.customer_pn"}
                                    value={formik?.values?.customer_data?.customer_pn || ""}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                        </Grid>
                    )}
                {/* <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                        Special Release Horb.
                    </p>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "15px 20px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "15px",
                            position: "relative",
                            boxShadow:
                                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                        }}
                    >
                        <input
                            style={{
                                outline: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                            }}
                            disabled={
                                readOnly
                            }
                            name={"customer_data.special_release_horb"}
                            value={formik?.values?.customer_data?.special_release_horb || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                    </div>
                </Grid> */}
                <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                        Name plate standard
                    </p>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "15px 20px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "15px",
                            position: "relative",
                            boxShadow:
                                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                        }}
                    >
                        <input
                            disabled={true}
                            style={{
                                outline: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                            }}
                            name={"customer_data.name_plate_standard"}
                            value={formik?.values?.customer_data?.name_plate_standard || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                    </div>
                </Grid>


                <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                        Approval Company (External)
                    </p>
                    {/* // se test certificate è No , defaultValue : 'without' */}
                    <MyAutocomplete
                        isMultiple={false}
                        disabled={
                            readOnly
                                ? readOnly
                                : data?.accessories?.find(
                                    (a) => a.value && a.value.accessory === "Register Classification"
                                )?.value?.value !== "Yes"
                        }
                        defaultValue={
                            formik?.values?.customer_data?.approval_company_external || null
                        } // Valore di default del campo customer
                        onChange={(e, c) => {
                            formik.setFieldValue(
                                "customer_data.approval_company_external",
                                c
                            );
                        }}
                        data={pickList?.approval_company_external || []} // Lista di opzioni
                        name="customer_data.approval_company_external"
                        label={""}
                    />
                </Grid>

                <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                        Test Certificate
                    </p>

                    <MyAutocomplete
                        isMultiple={false}
                        disabled={
                            readOnly
                                ? readOnly
                                : data?.accessories?.find(
                                    (a) => a.value.accessory === "Test Certificates"
                                )?.value?.value === "No"
                        }
                        defaultValue={
                            formik?.values?.customer_data?.test_certificate || null
                        } // Valore di default del campo customer
                        onChange={(e, c) => {
                            formik.setFieldValue("customer_data.test_certificate", c);
                        }}
                        data={pickList?.test_certificate || []} // Lista di opzioni
                        name="customer_data.test_certificate"
                        label={""}
                    />
                </Grid>

                <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>Language code</p>

                    <MyAutocomplete
                        isMultiple={false}
                        disabled={
                            readOnly
                                ? readOnly
                                : data?.accessories?.find(
                                    (a) => a.value.accessory === "Test Certificates"
                                )?.value?.value === "No"
                        }
                        defaultValue={
                            formik?.values?.customer_data?.language_code_f_test_certif || null
                        } // Valore di default del campo customer
                        onChange={(e, c) => {
                            formik.setFieldValue(
                                "customer_data.language_code_f_test_certif",
                                c
                            );
                        }}
                        data={pickList?.language_code_f_test_certif || []} // Lista di opzioni
                        name="customer_data.language_code_f_test_certif"
                        label={""}
                    />
                </Grid>

                <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>Paint/Primer</p>

                    <MyAutocomplete
                        isMultiple={false}
                        disabled={
                            readOnly
                                ? readOnly
                                : data?.accessories?.find((a) => a.family === "S6" || a.family === "S4")?.value
                                    ?.value === "No" &&
                                data?.accessories?.find((a) => a.family === "S7" || a.family === "S5")?.value
                                    ?.value === "No"
                        }
                        defaultValue={formik?.values?.customer_data?.paintprimer || null} // Valore di default del campo customer
                        onChange={(e, c) => {
                            formik.setFieldValue("customer_data.paintprimer", c);
                        }}
                        data={pickList?.paintprimer || []} // Lista di opzioni
                        name="customer_data.paintprimer"
                        label={""}
                    />
                </Grid>

                <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                        Paint/top coat
                    </p>

                    <MyAutocomplete
                        isMultiple={false}
                        disabled={
                            readOnly
                                ? readOnly
                                : data?.accessories?.find((a) => a.family === "S7" || a.family === "S5")?.value
                                    ?.value === "No"
                        }
                        defaultValue={formik?.values?.customer_data?.painttop_coat || null} // Valore di default del campo customer
                        onChange={(e, c) => {
                            formik.setFieldValue("customer_data.painttop_coat", c);
                        }}
                        data={pickList?.painttop_coat || []} // Lista di opzioni
                        name="customer_data.painttop_coat"
                        label={""}
                    />
                </Grid>

                <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                        Paint Specification
                    </p>

                    <MyAutocomplete
                        isMultiple={false}
                        disabled={
                            readOnly
                                ? readOnly
                                : data?.accessories?.find((a) => a.family === "S6" || a.family === "S4")?.value
                                    ?.value === "No" &&
                                data?.accessories?.find((a) => a.family === "S7" || a.family === "S5")?.value
                                    ?.value === "No"
                        }
                        defaultValue={
                            formik?.values?.customer_data?.paint_specification || null
                        } // Valore di default del campo customer
                        onChange={(e, c) => {
                            formik.setFieldValue("customer_data.paint_specification", c);
                        }}
                        data={pickList?.paint_specification || []} // Lista di opzioni
                        name="customer_data.paint_specification"
                        label={""}
                    />
                </Grid>



                <Grid item xs={12}>
                    <h2>TESTING RELEVANT DATA</h2>
                </Grid>

                <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                        Max displacement
                    </p>

                    <div
                        style={{
                            display: "flex",
                            gap: 3,
                            padding: "15px 20px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "15px",
                            position: "relative",
                            boxShadow:
                                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                        }}
                    >
                        <input
                            style={{
                                outline: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                            }}
                            disabled={readOnly}
                            type="number"
                            name={"testing_relevant_data.max_displacement"}
                            value={
                                formik?.values?.testing_relevant_data?.max_displacement
                            }
                            onChange={(e) => { handleChangeComputedValue(e, 'max_displacement', 'testing_relevant_data.max_displacement', 'testing_relevant_data.loaded_pump_speed') }}
                            onBlur={formik.handleBlur}
                        />
                    </div>
                </Grid>
                <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                        Min displacement
                    </p>

                    <div
                        style={{
                            display: "flex",
                            gap: 3,
                            padding: "15px 20px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "15px",
                            position: "relative",
                            boxShadow:
                                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                        }}
                    >
                        <input
                            style={{
                                outline: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                            }}
                            disabled={readOnly}
                            type="number"
                            name={"testing_relevant_data.min_displacement"}
                            value={
                                formik?.values?.testing_relevant_data?.min_displacement
                            }
                            onChange={(e) => { handleChangeComputedValue(e, 'min_displacement', 'testing_relevant_data.min_displacement', 'testing_relevant_data.loaded_pump_speed') }}
                            onBlur={formik.handleBlur}
                        />
                    </div>
                </Grid>

                <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                        Loaded Pump Speed
                    </p>

                    <div
                        style={{
                            display: "flex",
                            gap: 3,
                            padding: "15px 20px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "15px",
                            position: "relative",
                            boxShadow:
                                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                        }}
                    >
                        <input
                            style={{
                                outline: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                            }}
                            disabled={readOnly}
                            type="number"
                            name={"testing_relevant_data.loaded_pump_speed"}
                            value={
                                formik?.values?.testing_relevant_data?.loaded_pump_speed
                            }
                            onChange={(e) => { handleChangeComputedValue(e, 'loaded_pump_speed', 'testing_relevant_data.loaded_pump_speed', 'testing_relevant_data.max_displacement') }}
                            onBlur={formik.handleBlur}
                        />
                        <p style={{ color: "orange", fontSize: 12, fontWeight: "bold" }}>
                            Number between 500-2000 by increments of 50
                        </p>
                    </div>
                </Grid>
                <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                        Max Output Flow
                    </p>

                    <div
                        style={{
                            display: "flex",
                            gap: 3,
                            padding: "15px 20px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "15px",
                            position: "relative",
                            boxShadow:
                                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                        }}
                    >
                        <input
                            style={{
                                outline: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                            }}
                            disabled={true}
                            type="number"
                            name={"testing_relevant_data.max_output_flow"}
                            value={
                                formik?.values?.testing_relevant_data?.max_output_flow || ''
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />

                    </div>
                </Grid>
                <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                        Min Output Flow
                    </p>

                    <div
                        style={{
                            display: "flex",
                            gap: 3,
                            padding: "15px 20px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "15px",
                            position: "relative",
                            boxShadow:
                                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                        }}
                    >
                        <input
                            style={{
                                outline: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                            }}
                            disabled={true}
                            type="number"
                            name={"testing_relevant_data.min_output_flow"}
                            value={
                                formik?.values?.testing_relevant_data?.min_output_flow || 0
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />

                    </div>
                </Grid>


                {checkCodeIncludes(data?.specs?.find((spec) => spec.position_desc === 'Control device')?.value?.value, ["DR", "DFR", "DFR1", "DRG", "DFLR", "DRF", "DRS", "LA5D", "LA6D", "LA7D", "LA8D", "LA9D", "LA5DS", "LA6DS", "LA7DS", "LA8DS", "LA9DS", "LA5DG", "LA6DG", "LA7DG", "LA8DG", "LA9DG", "DRSC"]) && <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>Pressure regulation setting b</p>
                    <div
                        style={{
                            display: "flex",
                            gap: 3,
                            padding: "15px 20px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "15px",
                            position: "relative",
                            boxShadow:
                                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                        }}
                    >
                        <input
                            style={{
                                outline: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                            }}
                            disabled={readOnly}
                            type="number"
                            name={"testing_relevant_data.pressure_regulation_setting_b"}
                            value={formik?.values?.testing_relevant_data?.pressure_regulation_setting_b || ''}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        <p style={{ color: "orange", fontSize: 12, fontWeight: "bold" }}>
                            Number between 50-280 by increments of 5
                        </p>
                    </div>
                </Grid>}
                {checkCodeIncludes(data?.specs?.find((spec) => spec.position_desc === 'Control device')?.value?.value, ["DFR", "DFR1", "DFLR", "DRS", "DRF", "DRSC", "LA5S", "LA6S", "LA7S", "LA8S", "LA9S", "LA5DS", "LA6DS", "LA7DS", "LA8DS", "LA9DS", "LA5DG", "LA6DG", "LA7DG", "LA8DG", "LA9DG"]) && <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>Differential pressure fr</p>
                    <div
                        style={{
                            display: "flex",
                            gap: 3,
                            padding: "15px 20px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "15px",
                            position: "relative",
                            boxShadow:
                                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                        }}
                    >
                        <input
                            style={{
                                outline: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                            }}
                            disabled={readOnly}
                            type="number"
                            name={"testing_relevant_data.differential_pressure_fr"}
                            value={formik?.values?.testing_relevant_data?.differential_pressure_fr || ''}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        <p style={{ color: "orange", fontSize: 12, fontWeight: "bold" }}>
                            Number between 14-22 by increments of 1
                        </p>
                    </div>
                </Grid>}

                {checkCodeIncludes(data?.specs?.find((spec) => spec.position_desc === 'Control device')?.value?.value, ["DRG", "LA5DG", "LA6DG", "LA7DG", "LA8DG", "LA9DG"]) && <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}> Stanby pressure G controller</p>
                    <div
                        style={{
                            display: "flex",
                            gap: 3,
                            padding: "15px 20px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "15px",
                            position: "relative",
                            boxShadow:
                                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                        }}
                    >
                        <input
                            style={{
                                outline: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                            }}
                            disabled={readOnly}
                            type="number"
                            name={"testing_relevant_data.standby_pressure_g_controller"}
                            value={formik?.values?.testing_relevant_data?.standby_pressure_g_controller || ''}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        <p style={{ color: "orange", fontSize: 12, fontWeight: "bold" }}>
                            Number between 14-22 by increments of 1
                        </p>
                    </div>
                </Grid>}

                {data?.specs?.find((spec) => spec.position_desc === 'Control device')?.value?.value.includes('ED') && <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}> Stanby pressure ED</p>
                    <div
                        style={{
                            display: "flex",
                            gap: 3,
                            padding: "15px 20px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "15px",
                            position: "relative",
                            boxShadow:
                                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                        }}
                    >
                        <input
                            style={{
                                outline: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                            }}
                            disabled={readOnly}
                            type="number"
                            name={"testing_relevant_data.standby_pressure_ed"}
                            value={formik?.values?.testing_relevant_data?.standby_pressure_ed || ''}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        <p style={{ color: "orange", fontSize: 12, fontWeight: "bold" }}>
                            Number between 14-22 by increments of 1
                        </p>
                    </div>
                </Grid>}

                {data?.specs?.find((spec) => spec.position_desc === 'Control device')?.value?.value.includes('ER') && <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}> Stanby pressure ER</p>
                    <div
                        style={{
                            display: "flex",
                            gap: 3,
                            padding: "15px 20px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "15px",
                            position: "relative",
                            boxShadow:
                                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                        }}
                    >
                        <input
                            style={{
                                outline: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                            }}
                            disabled={readOnly}
                            type="number"
                            name={"testing_relevant_data.standby_pressure_er"}
                            value={formik?.values?.testing_relevant_data?.standby_pressure_er || ''}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        <p style={{ color: "orange", fontSize: 12, fontWeight: "bold" }}>
                            Number between 14-22 by increments of 1
                        </p>
                    </div>
                </Grid>}
                {checkCodeIncludes(data?.specs?.find((spec) => spec.position_desc === 'Control device')?.value?.value, ["LA5D", "LA6D", "LA7D", "LA8D", "LA9D", "LA5DS", "LA6DS", "LA7DS", "LA8DS", "LA9DS", "LA5DG", "LA6DG", "LA7DG", "LA8DG", "LA9DG", "LA5S", "LA6S", "LA7S", "LA8S", "LA9S", "DFLR"]) && <>
                    <Grid item xs={3}>
                        <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}> Input power</p>
                        <div
                            style={{
                                display: "flex",
                                gap: 3,
                                padding: "15px 20px",
                                backgroundColor: "rgba(255, 255, 255, 0.5)",
                                borderRadius: "15px",
                                position: "relative",
                                boxShadow:
                                    "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                            }}
                        >
                            <input
                                style={{
                                    outline: "none",
                                    border: "none",
                                    backgroundColor: "transparent",
                                    width: "100%",
                                }}
                                disabled={readOnly}
                                type="number"
                                name={"testing_relevant_data.input_power"}
                                value={formik?.values?.testing_relevant_data?.input_power || ''}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />

                        </div>
                    </Grid>

                    <Grid item xs={3}>
                        <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}> Input torque</p>
                        <div
                            style={{
                                display: "flex",
                                gap: 3,
                                padding: "15px 20px",
                                backgroundColor: "rgba(255, 255, 255, 0.5)",
                                borderRadius: "15px",
                                position: "relative",
                                boxShadow:
                                    "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                            }}
                        >
                            <input
                                style={{
                                    outline: "none",
                                    border: "none",
                                    backgroundColor: "transparent",
                                    width: "100%",
                                }}
                                disabled={true}
                                type="number"
                                name={"testing_relevant_data.input_torque"}
                                value={formik?.values?.testing_relevant_data?.input_torque || ''}
                                onChange={(e) => { handleChangeComputedValue(e, 'input_torque', 'testing_relevant_data.input_torque', 'testing_relevant_data.loaded_pump_speed') }}
                                onBlur={formik.handleBlur}
                            />

                        </div>
                    </Grid>

                </>}
                {/* testing_relevant_data: {




                  
              
               
               
               
                input_power:
                data?.schedeTaratura?.testing_relevant_data
                ?.input_power || 0,
                input_torque:
                data?.schedeTaratura?.testing_relevant_data
                ?.input_torque || 0,
            }, */}




                <Grid item xs={12}>
                    <h2>SPECIAL FEATURES</h2>
                </Grid>
                <Grid item xs={3}>
                    <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>Note</p>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "15px 20px",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            borderRadius: "15px",
                            position: "relative",
                            boxShadow:
                                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                        }}
                    >
                        <input
                            disabled={readOnly}
                            style={{
                                outline: "none",
                                border: "none",
                                backgroundColor: "transparent",
                                width: "100%",
                            }}
                            name={"special_features.note"}
                            value={formik?.values?.special_features?.note || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                    </div>
                </Grid>
            </Grid>

            {!readOnly && (
                <div style={{ padding: "30px 0" }}>
                    <Box mr={mq_xs ? 0 : 1}>
                        <Button
                            disabled={false}
                            variant="contained"
                            color="inherit"
                            size={mq_xs ? "small" : "medium"}
                            onClick={handleClick}
                        >
                            Confirm and go to Summary
                        </Button>
                    </Box>
                </div>
            )}
        </form>
    );
};

export default A10VO31;
